export const PagingPayload = {
  PageNumber: 1,
  PageSize: 1000,
};
